import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

interface UIState {
  theme: Theme;
  activeModal: string | null;
}

interface UIActions {
  setTheme: (theme: Theme) => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
}

export type UIStore = UIState & UIActions;

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      // State
      theme: 'system',
      activeModal: null,

      // Actions
      setTheme: (theme) => set({ theme }),

      openModal: (modalId) => set({ activeModal: modalId }),

      closeModal: () => set({ activeModal: null }),
    }),
    {
      name: 'singlist-ui',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
